import { pageCopySection } from './content/siteCopyHelpers';
import { BRAND_COPY_DEFAULTS, FOOTER_COPY_DEFAULTS } from './content/pageCopyDefaults';
import { resolveMediaUrl } from './productMediaUtils';
import { coerceSiteSettingBool } from './siteSettingsDefaults';

export function getBrandCopy(pageCopy) {
  const raw = pageCopy?.brand && typeof pageCopy.brand === 'object' ? pageCopy.brand : {};
  const name = String(raw.name ?? BRAND_COPY_DEFAULTS.name).trim() || BRAND_COPY_DEFAULTS.name;
  const logoUrl = String(raw.logo_url ?? BRAND_COPY_DEFAULTS.logo_url).trim() || BRAND_COPY_DEFAULTS.logo_url;
  const header_show_logo = coerceSiteSettingBool(
    raw.header_show_logo,
    BRAND_COPY_DEFAULTS.header_show_logo,
  );
  return { name, logo_url: logoUrl, header_show_logo };
}

export function brandNameFromSettings(settings) {
  return getBrandCopy(settings?.page_copy).name;
}

export function brandLogoSrcFromSettings(settings) {
  return resolveMediaUrl(getBrandCopy(settings?.page_copy).logo_url);
}

export function getFooterCopy(pageCopy) {
  const raw = pageCopy?.footer && typeof pageCopy.footer === 'object' ? pageCopy.footer : {};
  const exploreLegacy = String(raw.explore_heading ?? FOOTER_COPY_DEFAULTS.explore_heading).trim();
  const connectLegacy = String(raw.connect_heading ?? FOOTER_COPY_DEFAULTS.connect_heading).trim();
  return {
    about_heading:
      String(raw.about_heading ?? FOOTER_COPY_DEFAULTS.about_heading).trim() ||
      FOOTER_COPY_DEFAULTS.about_heading,
    shop_heading:
      String(raw.shop_heading ?? exploreLegacy ?? FOOTER_COPY_DEFAULTS.shop_heading).trim() ||
      FOOTER_COPY_DEFAULTS.shop_heading,
    customer_heading:
      String(raw.customer_heading ?? FOOTER_COPY_DEFAULTS.customer_heading).trim() ||
      FOOTER_COPY_DEFAULTS.customer_heading,
    policies_heading:
      String(raw.policies_heading ?? FOOTER_COPY_DEFAULTS.policies_heading).trim() ||
      FOOTER_COPY_DEFAULTS.policies_heading,
    explore_heading: exploreLegacy || FOOTER_COPY_DEFAULTS.explore_heading,
    connect_heading: connectLegacy || FOOTER_COPY_DEFAULTS.connect_heading,
    shipping_link_label:
      String(raw.shipping_link_label ?? FOOTER_COPY_DEFAULTS.shipping_link_label).trim() ||
      FOOTER_COPY_DEFAULTS.shipping_link_label,
    copyright_suffix:
      String(raw.copyright_suffix ?? FOOTER_COPY_DEFAULTS.copyright_suffix).trim() ||
      FOOTER_COPY_DEFAULTS.copyright_suffix,
  };
}

/** Append brand to SEO title when not already present. */
export function seoTitleWithBrand(title, brand) {
  const t = String(title || '').trim();
  const b = String(brand || BRAND_COPY_DEFAULTS.name).trim();
  if (!t) return b;
  if (t.toLowerCase().includes(b.toLowerCase())) return t;
  return `${t} | ${b}`;
}

export function pageEyebrow(settings) {
  return brandNameFromSettings(settings);
}

export function storeSeo(settings, key, fallbackTitle, fallbackDescription = '') {
  const store = settings?.store_copy || {};
  const brand = brandNameFromSettings(settings);
  const title = String(store[key] || fallbackTitle).trim() || fallbackTitle;
  const descKey = key.replace(/_title$/, '_description');
  const description = String(store[descKey] || fallbackDescription).trim() || fallbackDescription;
  return {
    title: seoTitleWithBrand(title, brand),
    description,
  };
}

export function formatPdpSeo(settings, { title, categoryLabel, description }) {
  const store = settings?.store_copy || {};
  const brand = brandNameFromSettings(settings);
  const titleTpl = String(store.seo_pdp_title_template || '{title} | {category} | {brand}');
  const descTpl = String(
    store.seo_pdp_description_template || '{description}'
  );
  const descFallback = `${title} — handcrafted ${categoryLabel} from ${brand}.`;
  const body = String(description || descFallback).slice(0, 160);

  const metaTitle = titleTpl
    .replace(/\{title\}/g, title)
    .replace(/\{category\}/g, categoryLabel)
    .replace(/\{brand\}/g, brand);

  const metaDesc = descTpl
    .replace(/\{title\}/g, title)
    .replace(/\{category\}/g, categoryLabel)
    .replace(/\{brand\}/g, brand)
    .replace(/\{description\}/g, body);

  return {
    title: metaTitle.slice(0, 120),
    description: metaDesc.slice(0, 160),
  };
}

export { pageCopySection };
